import { render, staticRenderFns } from "./LpuRelatedClinics.vue?vue&type=template&id=42e4757b&"
import script from "./LpuRelatedClinics.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuRelatedClinics.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e4757b')) {
      api.createRecord('42e4757b', component.options)
    } else {
      api.reload('42e4757b', component.options)
    }
    module.hot.accept("./LpuRelatedClinics.vue?vue&type=template&id=42e4757b&", function () {
      api.rerender('42e4757b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRelatedClinics/LpuRelatedClinics.vue"
export default component.exports